import { Component, EventEmitter, Input, Output, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { IUserCompany } from '@cakeiteasy/web-utils';

@Component({
  standalone: false,
  selector: 'register-business-account-form',
  templateUrl: './register-business-account-form.component.html',
  styleUrls: ['./register-business-account-form.component.scss']
})
export class RegisterBusinessAccountFormComponent implements OnInit {
  @Input() error: string = '';
  @Input() countryCode: string;
  @Input() bakeryId = null;
  @Output() onSubmit = new EventEmitter<any>();

  public subscribedOnNews: boolean = false;
  public userForm: FormGroup;
  public company: IUserCompany;
  public showPassword = false;

  constructor(private _fb: FormBuilder) {
    this.userForm = this._fb.group({
      fullName: ['', [Validators.required, Validators.maxLength(32)]],
      password: ['', [Validators.required, Validators.maxLength(32)]],
      email: ['', [Validators.email, Validators.required, Validators.maxLength(128)]],
    });
  }

  ngOnInit() {
  }

  public changeCompany() {
    this.company = null;
    this.error = '';
  }

  public continueWithCompany(company: IUserCompany) {
    this.company = company;
  }

  public submit() {
    const domainName = this.countryCode.toLowerCase();
    const domainLocaleMap = {
      'no': 'nb_NO',
      'se': 'sv_SE',
    };
    const model = {
      ...this.userForm.value,
      locale: domainLocaleMap[domainName] || 'nb_NO',
      subscribedOnNews: this.subscribedOnNews,
      companyId: this.company.id,
      orgNumber: this.company.legalCompany.orgNumber,
    };

    this.onSubmit.emit(model);
  }
}
